/* Nummora wishlist – localStorage, no app. Uses the same key as the old Ecomify theme so saved items carry over. */
(function () {
  var KEY = 'ecomify_wishlist_v1';

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function set(w) {
    try { localStorage.setItem(KEY, JSON.stringify(w)); } catch (e) {}
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    var f = window.nmMoneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  async function toggle(handle) {
    var w = get();
    if (w.some(function (i) { return i.handle === handle; })) {
      w = w.filter(function (i) { return i.handle !== handle; });
    } else {
      var r = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!r.ok) return;
      var p = await r.json();
      w.push({
        id: p.id, handle: p.handle, url: p.url, title: p.title,
        compare_at_price: p.compare_at_price, price: p.price, price_varies: p.price_varies,
        featured_image: p.featured_image, vendor: p.vendor, time: Date.now(),
        variants: p.variants.map(function (v) {
          return { id: v.id, title: v.title, compare_at_price: v.compare_at_price, price: v.price,
            featured_image: { src: (v.featured_image && v.featured_image.src) || null } };
        })
      });
    }
    set(w);
    sync();
  }

  function remove(handle) {
    set(get().filter(function (i) { return i.handle !== handle; }));
    sync();
  }

  function sync() {
    var w = get();
    document.querySelectorAll('[data-nm-wl-toggle]').forEach(function (b) {
      var on = w.some(function (i) { return i.handle === b.dataset.productHandle; });
      if (b.getAttribute('aria-pressed') !== (on ? 'true' : 'false')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-nm-wl-count]').forEach(function (c) {
      if (c.textContent !== String(w.length)) c.textContent = w.length;
      c.hidden = !w.length;
    });
    var list = document.getElementById('nm-wl-list');
    if (!list) return;
    var empty = document.getElementById('nm-wl-empty');
    empty.hidden = !!w.length;
    var html = w.map(function (p) {
      return '<li class="nm-wl__item">' +
        '<a href="' + esc(p.url) + '" class="nm-wl__img" tabindex="-1" aria-hidden="true">' +
          (p.featured_image ? '<img src="' + esc(img(p.featured_image, 200)) + '" alt="" width="80" height="80" loading="lazy">' : '') +
        '</a>' +
        '<div class="nm-wl__info">' +
          '<a href="' + esc(p.url) + '" class="nm-wl__title">' + esc(p.title) + '</a>' +
          '<p class="nm-wl__price">' +
            (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s> ' : '') +
            (p.price_varies ? 'From ' : '') + money(p.price) +
          '</p>' +
          '<a href="' + esc(p.url) + '" class="nm-wl__view">View kit</a>' +
        '</div>' +
        '<button type="button" class="nm-wl__remove" data-nm-wl-remove="' + esc(p.handle) + '" aria-label="Remove ' + esc(p.title) + ' from wishlist">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
        '</button>' +
      '</li>';
    }).join('');
    if (list.dataset.html !== html) { list.innerHTML = html; list.dataset.html = html; }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nm-wl-toggle]');
    if (t) { e.preventDefault(); toggle(t.dataset.productHandle); return; }
    var r = e.target.closest('[data-nm-wl-remove]');
    if (r) { remove(r.getAttribute('data-nm-wl-remove')); return; }
    var o = e.target.closest('[data-nm-wl-open]');
    if (o) {
      var d = document.getElementById('nm-wl');
      if (d) { sync(); d.showModal(); }
      return;
    }
    var c = e.target.closest('[data-nm-wl-close]');
    if (c) { c.closest('dialog').close(); return; }
    if (e.target.id === 'nm-wl') e.target.close();
  });

  // Horizon re-renders product blocks on variant change; keep button state in sync.
  var pending;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var n = muts[i].target;
      if (n.closest && n.closest('#nm-wl')) continue;
      clearTimeout(pending);
      pending = setTimeout(sync, 80);
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });
  window.nmWishlist = { toggle: toggle, remove: remove, sync: sync };
  sync();
})();
